import { Fragment, type FunctionComponent } from 'react';
import cx from 'classnames';
import { getImagesStaticUrl } from '../../helpers';
import { useUpgradeMembershipContext } from '../../utils/ContextProviders/UpgradeContext';

type MobileTableProps = {
  getCouponContentKey: (key: string, defaultValue: string) => string;
};

const MobileTable: FunctionComponent<MobileTableProps> = ({ getCouponContentKey }) => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const { variables } = growthUpgrade;
  const perks = variables.perks?.list ?? [];

  const perksList = perks.filter((perk) => !perk.skip.seasonal);

  return (
    <div className="desktopHidden">
      <table className="upgrade-plan-table">
        <tbody>
          <tr className="placeholderRow">
            <th />
            <th />
            <th className="tableHeader tableHeader__annual annualBorder">
              <img
                src={getImagesStaticUrl(
                  getCouponContentKey('bestValueImag', 'best-value-mobile.svg'),
                )}
                alt="best value"
              />
            </th>
          </tr>
          <tr>
            <th className="tableHeader__feature tableHeader">
              {getCouponContentKey('header1', 'Feature')}
            </th>
            <th className="tableHeader__seasonal tableHeader borderRightNone">
              {getCouponContentKey('header2', 'Seasonal')}
            </th>
            <th className="tableHeader tableHeader__annual annualBorder">
              {getCouponContentKey('header3', 'Annual')}
            </th>
          </tr>
          {perksList.map(({ label, mobileLabel, check }, index) => (
            <Fragment key={label}>
              <tr className="featureRow">
                <th className="tableFeatures">{mobileLabel || label}</th>
                <td>
                  <i
                    className={cx('far', {
                      'fa-times': !check.seasonal,
                      timesIcon: !check.seasonal,
                      'fa-check': check.seasonal,
                      checkIcon: check.seasonal,
                    })}
                  />
                </td>
                <td
                  className={cx('annualSideBorder', {
                    annualBottomBorder: perksList.length - 1 === index,
                  })}
                >
                  <i className="far fa-check checkIcon" />
                </td>
              </tr>
              <tr className="tableDivider" />
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MobileTable;
